export enum OfferType {
  FLAT,
  PERCENTAGE,
}

export enum OfferStatus {
  INACTIVE,
  ACTIVE,
}

export enum OfferUsedStatus {
  NOT_USED,
  USED,
}

export enum HotDealStatus {
  NOT_HOT_DEAL,
  HOT_DEAL,
}

export enum BuyStatus {
  NOT_REDEEMED,
  REDEEMED,
}

export type OfferItem = {
  buyStatus: BuyStatus
  categories: {
    name: string
    id: string
  }
  categoryId: string
  description: string
  discountCode: string
  discountUsed: OfferUsedStatus
  endDate: string | null
  hotDeal: HotDealStatus
  id: string
  image: string
  locations: string[]
  merchant: {
    name: string
    email: string
    logo: string
  }
  merchantId: string
  merchantUrl: string
  offerLeft: number | null
  points: string
  shopLogo: string
  shopName: string
  startDate: string | null
  status: OfferStatus
  title: string
  totalCount: number | null
  type: OfferType
  usedCount: number | null
  /**
   * **value**, depends on `type` filed value
   *
   * `if (type === OfferType.FLAT)` it will have normal number value
   *
   * `if (type === OfferType.PERCENTAGE)` it will have percent number value
   */
  value: string
}

export type OfferList = OfferItem[]

//OFFER LIST

export type OffersListInput = {
  categoryId?: string[]
  fromCoin?: number
  isRedeemed?: BuyStatus
  limit?: number
  locations?: string[]
  offset?: number
  toCoin?: number
}

export type OffersListResponse = {
  offers: OfferList
  success: boolean
}

// OFFER DETAILS
export type OfferDetailsInput = {
  offerId: string
}

export type OfferDetailsResponse = {
  success: boolean
  offer: OfferItem
}

// REDEEM OFFER
export type RedeemOfferInput = {
  offerId: string
}

export type RedeemOfferResponse = {
  success: boolean
  code: string
  points: number
  usedPoints: string
  value: string
  type: OfferType
}
